import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  message,
  Select,
  Slider,
  Typography,
} from "antd";
import gptModelSettingsApi from "./gptModel.api";

const { Title } = Typography;

const GptModelForm = () => {
  const [form] = Form.useForm();
  const [gptModels, setGptModels] = useState([]);
  const [freqValue, setFreqValue] = useState(1);
  const [penaltyValue, setPenaltyValue] = useState(1);
  const [temperature, setTemp] = useState(1);
  const [topP, setTopP] = useState(1);

  const onFreqChange = (newValue) => {
    setFreqValue(newValue);
    form.setFieldValue({ frequency_penalty: newValue });
  };

  const onPenaltyChange = (newValue) => {
    setPenaltyValue(newValue);
    form.setFieldValue({ presence_penalty: newValue });
  };

  const onTempChange = (newValue) => {
    setTemp(newValue);
    form.setFieldsValue({ temperature: newValue });
  };

  const onTopPChange = (newValue) => {
    setTopP(newValue);
    form.setFieldsValue({ topP: newValue });
  };

  const fetchSavedGptModel = async () => {
    const response = await gptModelSettingsApi.getSavedGptModel();

    setFreqValue(response.data.frequency_penalty);
    setTemp(response.data.temperature);
    setPenaltyValue(response.data.presence_penalty);
    setTopP(response.data.top_p);

    form.setFieldsValue({
      max_token: response.data.max_token,
      gptModel: "gpt4o-cc-chat",
      top_p: response.data.top_p,
      temperature: response.data.temperature,
      presence_penalty: response.data.presence_penalty,
      frequency_penalty: response.data.frequency_penalty,
    });
  };

  const onReset = async () => {
    form.setFieldsValue({
      max_token: 16,
      top_p: 1,
      temperature: 1,
      presence_penalty: 0,
      frequency_penalty: 0,
    });

    setFreqValue(0);
    setPenaltyValue(0);
    setTopP(1);
    setTemp(1);

    await handleUpdate({
      max_token: 16,
      top_p: 1,
      temperature: 1,
      presence_penalty: 0,
      frequency_penalty: 0,
      gptModel: "gpt4o-cc-chat",
    });
  };

  const handleUpdate = async (values) => {
    try {
      await gptModelSettingsApi.updateGptModel(values);
      message.success("GPT Model updated successfully!");
    } catch (error) {
      message.error("Failed to update GPT Model");
    }
  };

  useEffect(() => {
    fetchSavedGptModel();
  }, []);

  return (
    <div className="page-shell">
      <div className="page-heading-row">
        <Title level={1}>Settings</Title>
      </div>

      <Form
        form={form}
        onFinish={handleUpdate}
        layout="vertical"
        style={{ maxWidth: 720 }}
      >
        <Form.Item
          label="GPT Model"
          name="gptModel"
          rules={[{ required: true }]}
        >
          <Input disabled />
        </Form.Item>

        <Form.Item label="Temperature" name="temperature">
          <Slider
            min={0}
            max={2}
            onChange={onTempChange}
            value={temperature}
            step={0.1}
            marks={{
              0: "0",
              2: "2",
              [temperature]: {
                style: { color: "#f50" },
                label: <span style={{ fontWeight: "bold" }}>{temperature}</span>,
              },
            }}
          />
        </Form.Item>

        <Form.Item
          label="Maximum Tokens"
          name="max_token"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item label="Top_P" name="top_p" rules={[{ required: true }]}>
          <Slider
            min={0}
            max={1}
            onChange={onTopPChange}
            value={topP}
            step={0.01}
            marks={{
              0: "0",
              1: "1",
              [topP]: {
                style: { color: "#f50" },
                label: <span style={{ fontWeight: "bold" }}>{topP}</span>,
              },
            }}
          />
        </Form.Item>

        <Form.Item
          label="Frequency Penalty"
          name="frequency_penalty"
          rules={[{ required: true }]}
        >
          <Slider
            min={-2}
            max={2}
            onChange={onFreqChange}
            value={typeof freqValue === "number" ? freqValue : 0}
            step={0.1}
            marks={{
              [-2]: "-2",
              2: "2",
              [freqValue]: {
                style: { color: "#f50" },
                label: <span style={{ fontWeight: "bold" }}>{freqValue}</span>,
              },
            }}
          />
        </Form.Item>

        <Form.Item label="Presence Penalty" name="presence_penalty">
          <Slider
            min={-2}
            max={2}
            onChange={onPenaltyChange}
            value={typeof penaltyValue === "number" ? penaltyValue : 0}
            step={0.1}
            marks={{
              [-2]: "-2",
              2: "2",
              [penaltyValue]: {
                style: { color: "#f50" },
                label: (
                  <span style={{ fontWeight: "bold" }}>{penaltyValue}</span>
                ),
              },
            }}
          />
        </Form.Item>

        <div className="settings-actions">
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Update Settings
            </Button>
          </Form.Item>

          <Form.Item>
            <Button onClick={onReset}>Reset Settings</Button>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default GptModelForm;